import axios from "axios";
import config from "@/router/globalConfig";

export default {
    //============= Post API ===============
    SetOnlineNominee(_data_) {
        return axios.post(config.WEB_API_PATH + 'nominatingAuth/v1/SetOnlineNominee', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    SetOnlineMasterAccountData(_data_) {
        return axios.post(config.WEB_API_PATH + 'nominatingAuth/v1/SetOnlineMasterData', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    //======================================
    //============== Get API ===============
    GetOnlineNominee(_data_) {
        return axios.get(config.WEB_API_PATH + 'nominatingAuth/v1/GetOnlineNominee', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetMasterAccountList(_data_) {
        return axios.get(config.WEB_API_PATH + 'nominatingAuth/v1/GetMasterAccountList', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    //======================================
}


// WEBPACK FOOTER //
// ./src/components/serviceJS/NomineeAuth.js